class UserModel {
    constructor({
      balance,
      date,
      dateTime,
      emailId,
      firstName,
      gender,
      imageUrl,
      myQrCode,
      myQrCodeNo,
      password,
      phoneNo,
      restaurantAddress,
      restaurantBarNo,
      restaurantGstNo,
      restaurantId,
      restaurantKitchenNo,
      restaurantName,
      restaurantPhoneNo,
      search,
      status,
      statusType,
      time,
      type,
      userType,
      priorityUser,
      companyName,
    }) {
      this.balance = balance;
      this.date = date;
      this.dateTime = dateTime;
      this.emailId = emailId;
      this.firstName = firstName;
      this.gender = gender;
      this.imageUrl = imageUrl;
      this.myQrCode = myQrCode;
      this.myQrCodeNo = myQrCodeNo;
      this.password = password;
      this.phoneNo = phoneNo;
      this.restaurantAddress = restaurantAddress;
      this.restaurantBarNo = restaurantBarNo;
      this.restaurantGstNo = restaurantGstNo;
      this.restaurantId = restaurantId;
      this.restaurantKitchenNo = restaurantKitchenNo;
      this.restaurantName = restaurantName;
      this.restaurantPhoneNo = restaurantPhoneNo;
      this.search = search;
      this.status = status;
      this.statusType = statusType;
      this.time = time;
      this.type = type;
      this.userType = userType;
      this.priorityUser = priorityUser;
      this.companyName = companyName;
    }
  
    static fromJson(json) {
      return new UserModel({
        balance: json.balance,
        date: json.date,
        dateTime: json.dateTime,
        emailId: json.emailId,
        firstName: json.firstName,
        gender: json.gender,
        imageUrl: json.imageURL,
        myQrCode: json.myQRCode,
        myQrCodeNo: json.myQRCodeNo,
        password: json.password,
        phoneNo: json.phoneNo,
        restaurantAddress: json.restaurantAddress,
        restaurantBarNo: json.restaurantBarNo,
        restaurantGstNo: json.restaurantGstNo,
        restaurantId: json.restaurantId,
        restaurantKitchenNo: json.restaurantKitchenNo,
        restaurantName: json.restaurantName,
        restaurantPhoneNo: json.restaurantPhoneNo,
        search: json.search,
        status: json.status,
        statusType: json.statusType,
        time: json.time,
        type: json.type,
        userType: json.userType,
        priorityUser: json.priorityUser ?? "N",
        companyName: json.companyName ?? "",
      });
    }
  
    toJson() {
      return {
        balance: this.balance,
        date: this.date,
        dateTime: this.dateTime,
        emailId: this.emailId,
        firstName: this.firstName,
        gender: this.gender,
        imageURL: this.imageUrl,
        myQRCode: this.myQrCode,
        myQRCodeNo: this.myQrCodeNo,
        password: this.password,
        phoneNo: this.phoneNo,
        restaurantAddress: this.restaurantAddress,
        restaurantBarNo: this.restaurantBarNo,
        restaurantGstNo: this.restaurantGstNo,
        restaurantId: this.restaurantId,
        restaurantKitchenNo: this.restaurantKitchenNo,
        restaurantName: this.restaurantName,
        restaurantPhoneNo: this.restaurantPhoneNo,
        search: this.search,
        status: this.status,
        statusType: this.statusType,
        time: this.time,
        type: this.type,
        userType: this.userType,
        priorityUser: this.priorityUser,
        companyName: this.companyName,
      };
    }
  }
  

export default UserModel;